/** Identity job titles assigned to third-party agents using Atlassian MCP. */
export const DCR3P_AGENT_JOB_TITLE = 'ai.dcr3p';
export const CIMD_MCP_AGENT_JOB_TITLE = 'ai.cimd-mcp';
